// extracted by mini-css-extract-plugin
export default {"textWhite":"ListingItemCarousel_textWhite__QXZrD","carouselItem":"ListingItemCarousel_carouselItem__Sw3gn"};